export default __webpack_public_path__ + "static/media/arrow_forward_black_-7@2x.f7b9a14a.png";